import BaseService from '@/features/BaseService';

export default class BillingReportService extends BaseService {

  constructor() {
    super('billing-report');
  }

}



// WEBPACK FOOTER //
// ./src/features/billing-report/BillingReportService.js